import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Elevated admins land on dashboard; staff on timetable. */
export default function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user?.is_elevated_admin ? "/dashboard" : "/timetable"} replace />;
}
